import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ClockIcon } from '@moia-dev/pace-icons'
import { EmployeeTimeManagementAreaRoutes } from './EmployeeTimeManagementAreaRoutes'

export const EmployeeTimeManagementAreaNavigationIcon = ClockIcon

export const EmployeeTimeManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={EmployeeTimeManagementAreaRoutes.route}
      Icon={ClockIcon}
    />
  )
}
